import { formatPriceAmount } from "../../../../utils/numbers"
import {
	InboundArs,
	TableOrderArs,
	taxNames,
} from "../../../tables/transactions-table/data/types"

import Col from "../../../ui/layouts/column"
import BodyItem from "./BodyItem"

const TransactionsAccordion = ({ tx }: { tx: InboundArs | TableOrderArs }) => {
	return (
		<>
			{tx.taxes && tx.taxes.taxes && Number(tx.taxes.total_tax_amount) > 0 && (
				<Col className="items-start gap-1">
					<div className="text-h6 font-semibold">Impuestos</div>

					{tx.taxes?.taxes?.map((tax) => {
						return (
							<BodyItem
								key={tax.tax_type}
								name={`${taxNames[tax.tax_type]} ${tax.tax_rate}%`}
								value={`-${formatPriceAmount(tax.tax_amount)} ARS`}
							/>
						)
					})}

					<BodyItem
						name="Total a descontar"
						value={`-${formatPriceAmount(tx.taxes?.total_tax_amount)} ARS`}
					/>
				</Col>
			)}
		</>
	)
}
// <Accordion
// 	type="single"
// 	collapsible
// 	className="py-3 border-t border-border"
// >
// 	<AccordionItem value={"transaction.transactionId"} className="border-b-0">
// 		<AccordionTrigger>

// 		</AccordionTrigger>
// 		<AccordionContent>

// 		</AccordionContent>
// 	</AccordionItem>
// </Accordion>

export default TransactionsAccordion
